// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5-iD9","title":"styles_title__q0hfY","subtitle":"styles_subtitle__xUTbG","paragraph":"styles_paragraph__HqWW5"};